const initialState = {
    isDeletingTagCategory: false,
    isUpdatingTagCategory: false,
    updatingCategory: null
}

export default initialState;
